// extracted by mini-css-extract-plugin
export default {"tile_container":"bba","tile_img_container":"cba","not_recommended_label":"eba","modal_root":"fba","content":"gba","warning":"hba","x_mark":"iba","tile_img":"jba","tile_type":"kba","tile_product_title":"lba","tile_product_price":"mba","tile_descr_line":"nba","tile_descr_icon":"oba","info_icon":"pba","tile_descr_text":"qba","tile_btns_container":"rba","info_container":"sba","info_text":"tba"};
    if(module.hot) {
      // 1737143665293
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  